import React from 'react';
import { Outlet } from 'react-router-dom';

const Men = () => {
  return <Outlet />;
};

export default Men;
